<app-page-title title="POS İşlemleri" [breadcrumbItems]="breadCrumbItems"></app-page-title>

<!-- ══ KPI satırı: dönem ve cihaz süzgecine göre (durum süzgeci uygulanmaz) ══ -->
<div class="row g-3 mb-3">
  <div class="col-xl-3 col-md-6">
    <app-kpi-card label="Net Tahsilat" icon="bx bx-wallet" tone="accent" [loading]="summaryLoading"
                  [value]="money(summary?.netAmount)" [extras]="netExtras" [comparison]="periodLabel">
    </app-kpi-card>
  </div>
  <div class="col-xl-3 col-md-6">
    <app-kpi-card label="Onaylı Kart Çekimi" icon="bx bx-credit-card" tone="success" [loading]="summaryLoading"
                  [value]="money(summary?.approvedSaleAmount)" [extras]="saleExtras">
    </app-kpi-card>
  </div>
  <div class="col-xl-3 col-md-6">
    <app-kpi-card label="İptal ve İade" icon="bx bx-undo" tone="danger" [loading]="summaryLoading"
                  [value]="money((summary?.voidAmount || 0) + (summary?.refundAmount || 0))" [extras]="voidExtras">
    </app-kpi-card>
  </div>
  <div class="col-xl-3 col-md-6">
    <app-kpi-card label="Satışa Bağlanmamış Çekim" icon="bx bx-unlink" [tone]="unlinkedCount ? 'warning' : 'info'"
                  [loading]="summaryLoading" [value]="(summary?.unlinkedCount || 0) + ' işlem'" [extras]="attentionExtras">
    </app-kpi-card>
  </div>
</div>

<div class="alert alert-warning d-flex gap-2 py-2 align-items-center" *ngIf="unlinkedCount">
  <i class="bx bx-error fs-4"></i>
  <div class="small flex-grow-1">
    <b>{{ unlinkedCount }}</b> onaylı kart çekimi bir satışa bağlanmamış: müşterinin kartından para çekildi ama
    satış kaydı yazılmadı. Satışı hızlı satıştan tamamlayın ya da işlemi cihazdan iptal edin.
  </div>
  <button type="button" class="btn btn-sm btn-outline-warning" *ngIf="!request.filter.onlyUnlinked"
          (click)="request.filter.onlyUnlinked = true; reloadData(true)">Göster</button>
</div>

<!--
  E-fatura listesiyle aynı düzen: sık kullanılan seçim dışarıda, gerisi
  "Filtreler" menüsünde. Menüdeki alanlar değişince liste hemen yenilenir;
  "Filtrele" yalnızca yenileyip menüyü kapatır.
-->
<div class="d-flex gap-2 mb-2 justify-content-end">
  <div class="d-flex gap-2">
    <select class="form-select" style="min-width: 220px" aria-label="Cihaz"
            [(ngModel)]="request.filter.posDeviceId" (change)="reloadData(true)">
      <option [ngValue]="null">Tüm Cihazlar</option>
      <option *ngFor="let d of devices" [ngValue]="d.id">{{ d.name }}</option>
    </select>
    <div ngbDropdown #filterDropdown="ngbDropdown" autoClose="outside" placement="bottom-right">
      <button type="button" class="btn btn-light text-nowrap" ngbDropdownToggle>
        <i class="bx bx-filter-alt me-1"></i>Filtreler
        <span class="badge bg-primary ms-1" *ngIf="panelFilterCount">{{ panelFilterCount }}</span>
        <i class="mdi mdi-chevron-down ms-1"></i>
      </button>
      <div ngbDropdownMenu class="dropdown-menu-end p-3" style="width: 320px;">
        <div class="mb-2">
          <label class="form-label">Tarih Aralığı</label>
          <app-date-range-filter [(start)]="dateStart" [(end)]="dateEnd"
                                 (rangeChange)="onDateRangeChange()"></app-date-range-filter>
        </div>
        <div class="mb-2">
          <label class="form-label">Durum</label>
          <select class="form-select" [(ngModel)]="request.filter.status" (change)="reloadData(true)">
            <option [ngValue]="null">Tüm Durumlar</option>
            <option *ngFor="let s of statuses" [ngValue]="s">{{ statusLabels[s] }}</option>
          </select>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="pos-only-unlinked"
                 [(ngModel)]="request.filter.onlyUnlinked" (change)="reloadData(true)">
          <label class="form-check-label" for="pos-only-unlinked">Yalnızca satışa bağlanmamış</label>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-primary flex-grow-1"
                  (click)="reloadData(true); filterDropdown.close()">Filtrele</button>
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilter()" title="Temizle">
            <i class="bx bx-x"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body p-0 position-relative">
    <list-spinner class="center-body" [ngClass]="{'position-absolute': transactions.length > 0}" [showSpinner]="Loading" [length]="transactions.length"></list-spinner>

    <div class="table-responsive" [ngClass]="{'blur-content': Loading}" *ngIf="transactions.length > 0">
      <table class="table table-hover align-middle mb-0">
        <thead>
          <tr>
            <th appSortHeader="submittedAt" [sort]="sort" (sortChange)="onSort($event)">Tarih</th>
            <th appSortHeader="deviceName" [sort]="sort" (sortChange)="onSort($event)">Cihaz / Kasa</th>
            <th appSortHeader="type" [sort]="sort" (sortChange)="onSort($event)">Tür</th>
            <th class="text-end" appSortHeader="amount" [sort]="sort" (sortChange)="onSort($event)">Tutar</th>
            <th appSortHeader="status" [sort]="sort" (sortChange)="onSort($event)">Durum</th>
            <th appSortHeader="documentNumber" [sort]="sort" (sortChange)="onSort($event)">Belge</th>
            <th>Kart</th>
            <th>Satış</th>
            <th class="text-end">İşlemler</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of transactions; trackBy: trackById" [class.table-warning]="isUnlinked(t)"
              [class.pos-row-flash]="flashIds.has(t.id)">
            <td class="text-nowrap small">
              {{ t.submittedAt | date:'dd.MM.yyyy HH:mm' }}
              <div class="text-muted font-monospace" style="font-size: .7rem">{{ t.reference }}</div>
            </td>
            <td class="small">
              {{ t.deviceName }}
              <div class="text-muted">{{ t.caseName }}</div>
            </td>
            <td class="small">
              <span *ngIf="t.type === Type.Sale">Satış</span>
              <span *ngIf="t.type === Type.Void" class="text-danger">İptal</span>
              <span *ngIf="t.type === Type.Refund" class="text-danger">İade</span>
              <div class="text-muted">{{ lineModeLabels[t.lineMode] }}</div>
            </td>
            <td class="text-end text-nowrap">
              <b>{{ t.amount | number:'1.2-2' }} ₺</b>
              <div class="small text-muted" *ngIf="t.installmentCount && t.installmentCount > 1">{{ t.installmentCount }} taksit</div>
            </td>
            <td>
              <span class="badge bg-{{ statusColor(t.status) }}">{{ statusLabel(t.type, t.status) }}</span>
              <div class="small text-muted" *ngIf="isVoided(t)"><i class="bx bx-undo"></i> Karta iade edildi</div>
              <div class="small text-muted text-nowrap" *ngIf="t.refundedAmount">
                <i class="bx bx-revision"></i> {{ t.refundedAmount | number:'1.2-2' }} ₺ iade edildi
              </div>
              <div class="small text-muted" *ngIf="t.hasOpenRefund">İade sürüyor</div>
              <div class="small text-muted" *ngIf="t.cancelRequestedAt && !t.isFinal">İptal istendi</div>
              <div class="small text-danger text-truncate" style="max-width: 200px" *ngIf="t.errorMessage" [title]="t.errorMessage">
                {{ t.errorMessage }}
              </div>
            </td>
            <td class="small">
              <span [class.text-danger]="t.documentStatus === DocumentStatus.Failed">{{ documentLabels[t.documentStatus] }}</span>
              <div class="text-muted font-monospace" *ngIf="t.documentNumber">{{ t.documentNumber }}</div>
            </td>
            <td class="small font-monospace">
              {{ t.maskedPan }}
              <div class="text-muted" *ngIf="t.authCode">Onay {{ t.authCode }}</div>
            </td>
            <td class="small text-nowrap">
              <!-- Ürünlü satış satış detayına, yalnızca alım/satım satırlı satış alım/satım kaydına gider -->
              <a *ngIf="t.salesId" routerLink="/retail/fast-selling/detail/{{ t.salesId }}" ngbTooltip="Satışa git" container="body">
                <i class="bx bx-link"></i> Satış #{{ t.salesId }}
              </a>
              <a *ngIf="!t.salesId && t.salesExchangeId" routerLink="/exchange/detail/{{ t.salesExchangeId }}"
                 ngbTooltip="Alım/satım kaydına git" container="body">
                <i class="bx bx-link"></i> Alım/Satım #{{ t.salesExchangeId }}
              </a>
              <span *ngIf="!t.salesId && !t.salesExchangeId && t.salesGroupId" class="text-success"><i class="bx bx-link"></i> Bağlı</span>
              <!-- İptal ve iade kaydı satışa değil iptal/iade ettiği çekime bağlıdır -->
              <a *ngIf="t.type !== Type.Sale && t.originalTransactionId" href="javascript:void(0)" (click)="openDetailById(t.originalTransactionId)"
                 [ngbTooltip]="t.type === Type.Refund ? 'İade yapılan kart çekiminin ayrıntısı' : 'İptal edilen kart çekiminin ayrıntısı'" container="body">
                <i class="bx bx-undo"></i> Asıl çekim
              </a>
              <span *ngIf="isUnlinked(t)" class="text-warning fw-semibold"><i class="bx bx-unlink"></i> Bağlanmadı</span>
            </td>
            <td class="text-end text-nowrap">
              <span class="spinner-border spinner-border-sm text-primary me-1" *ngIf="busyId === t.id"></span>
              <button class="btn btn-sm btn-light me-1" (click)="openDetail(t)" ngbTooltip="Ayrıntı" container="body">
                <i class="bx bx-detail"></i>
              </button>
              <button class="btn btn-sm btn-light me-1" *ngIf="canRefresh(t)" (click)="refresh(t)" [disabled]="busyId !== null"
                      ngbTooltip="Durumu sağlayıcıdan oku" container="body">
                <i class="bx bx-refresh"></i>
              </button>
              <button class="btn btn-sm btn-light text-warning me-1" *ngIf="canCancel(t)" (click)="cancel(t)" [disabled]="busyId !== null"
                      ngbTooltip="Cihazdaki isteği geri çek" container="body">
                <i class="bx bx-x-circle"></i>
              </button>
              <button class="btn btn-sm btn-light text-danger me-1" *ngIf="canRefund(t)" (click)="refund(t)" [disabled]="busyId !== null"
                      ngbTooltip="Seçilen satırları cihazdan iade et" container="body">
                <i class="bx bx-revision"></i>
              </button>
              <button class="btn btn-sm btn-light text-danger" *ngIf="canVoid(t)" (click)="void(t)" [disabled]="busyId !== null"
                      ngbTooltip="Onaylı satışı cihazdan iptal et (karta iade)" container="body">
                <i class="bx bx-undo"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="empty-state p-5 text-center" *ngIf="!Loading && transactions.length === 0">
      <div class="fs-1 text-muted mb-2"><i class="bx bx-credit-card"></i></div>
      <h5 class="mb-2">POS işlemi bulunamadı</h5>
      <p class="text-muted mb-3">Tarih aralığını genişletebilir ya da filtreleri temizleyebilirsiniz.</p>
      <button type="button" class="btn btn-outline-primary" (click)="clearFilter()" *ngIf="activeFilterCount > 0">Filtreleri Temizle</button>
    </div>
  </div>
</div>

<div *ngIf="response?.data?.Items?.length > 0" class="mt-3">
  <app-pagination
    [blurOn]="Loading"
    [pageInfo]="response.data"
    [pageRequest]="request"
    (requestEvent)="reloadData()">
  </app-pagination>
</div>

<!-- ══════════════ Ayrıntı ══════════════ -->
<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">POS İşlemi <span class="font-monospace small text-muted" *ngIf="detail">{{ detail.reference }}</span></h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="detailLoading" class="text-center py-3"><div class="spinner-border text-primary"></div></div>
    <ng-container *ngIf="detail">
      <div class="row g-2 small mb-3">
        <div class="col-md-3"><span class="text-muted">Durum:</span>
          <span class="badge bg-{{ statusColor(detail.status) }} ms-1">{{ statusLabel(detail.type, detail.status) }}</span>
          <span class="text-muted ms-1" *ngIf="detail.providerStatus">({{ detail.providerStatus }})</span>
        </div>
        <div class="col-md-3"><span class="text-muted">Belge:</span> {{ documentLabels[detail.documentStatus] }} {{ detail.documentNumber }}</div>
        <div class="col-md-3"><span class="text-muted">Tutar:</span> <b>{{ detail.amount | number:'1.2-2' }} ₺</b></div>
        <div class="col-md-3"><span class="text-muted">Satış tutarı:</span>
          {{ detail.paymentAmount | number:'1.2-3' }} {{ detail.paymentCurrency | priceCurrency: detail.paymentSubType }}
        </div>
        <div class="col-md-3"><span class="text-muted">Sağlayıcı no:</span> <span class="font-monospace">{{ detail.providerTransactionId || '—' }}</span></div>
        <div class="col-md-3"><span class="text-muted">Satış no:</span> <span class="font-monospace">{{ detail.providerSaleNumber || '—' }}</span></div>
        <div class="col-md-3"><span class="text-muted">Gönderim:</span> {{ detail.submittedAt | date:'dd.MM.yyyy HH:mm:ss' }}</div>
        <div class="col-md-3"><span class="text-muted">Sonuç:</span> {{ (detail.completedAt | date:'dd.MM.yyyy HH:mm:ss') || '—' }}</div>
        <div class="col-md-6"><span class="text-muted">Bağlı satış:</span>
          <a *ngIf="detail.salesId" class="ms-1" routerLink="/retail/fast-selling/detail/{{ detail.salesId }}" (click)="modal.close()">
            <i class="bx bx-link"></i> Satış #{{ detail.salesId }}
          </a>
          <a *ngIf="!detail.salesId && detail.salesExchangeId" class="ms-1" routerLink="/exchange/detail/{{ detail.salesExchangeId }}" (click)="modal.close()">
            <i class="bx bx-link"></i> Alım/Satım #{{ detail.salesExchangeId }}
          </a>
          <a *ngIf="detail.type !== Type.Sale && detail.originalTransactionId" class="ms-1" href="javascript:void(0)"
             (click)="loadDetail(detail.originalTransactionId)">
            <i class="bx bx-undo"></i> {{ detail.type === Type.Refund ? 'İade yapılan çekim' : 'İptal edilen çekim' }}
          </a>
          <span class="ms-1 text-muted"
                *ngIf="!detail.salesId && !detail.salesExchangeId && !(detail.type !== Type.Sale && detail.originalTransactionId)">
            {{ detail.salesGroupId ? 'Bağlı' : 'Bağlanmadı' }}
          </span>
        </div>
      </div>

      <div class="alert alert-danger py-2 small" *ngIf="detail.errorMessage">
        <b *ngIf="detail.errorCode">{{ detail.errorCode }}:</b> {{ detail.errorMessage }}
      </div>

      <!-- Cihazın düzenlediği mali belgeler; görüntüleme sağlayıcının satış sayfasında -->
      <ng-container *ngIf="detailDocuments.documents.length || detailDocuments.viewUrl">
        <div class="d-flex align-items-center mb-1">
          <h6 class="mb-0">{{ detail.type === Type.Void ? 'İptal edilen satışın belgeleri' : detail.type === Type.Refund ? 'İade belgeleri' : 'Belgeler' }}</h6>
          <a *ngIf="detailDocuments.viewUrl" class="btn btn-sm btn-outline-primary ms-auto" [href]="detailDocuments.viewUrl"
             target="_blank" rel="noopener">
            <i class="bx bx-show me-1"></i>Belgeyi Görüntüle
          </a>
        </div>
        <div class="table-responsive mb-3" *ngIf="detailDocuments.documents.length">
          <table class="table table-sm mb-0">
            <thead class="table-light">
              <tr><th>Tür</th><th>Belge No</th><th>ETTN</th><th></th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of detailDocuments.documents">
                <td>{{ d.typeName || '—' }}</td>
                <td class="font-monospace">{{ d.invoiceNo || '—' }}</td>
                <td class="font-monospace small text-muted">{{ d.documentNo || '—' }}</td>
                <td class="text-end">
                  <a *ngIf="detailDocuments.viewUrl" [href]="detailDocuments.viewUrl" target="_blank" rel="noopener"
                     ngbTooltip="Sağlayıcının satış sayfasında aç" container="body">
                    <i class="bx bx-link-external"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <div class="small text-muted mb-2" *ngIf="detail.refundedAmount">
        <i class="bx bx-revision"></i> Bu çekimden {{ detail.refundedAmount | number:'1.2-2' }} ₺ satır iadesi yapıldı.
      </div>
      <h6 *ngIf="detail.lines?.length">{{ detail.type === Type.Refund ? 'İade edilen satırlar' : 'Belge satırları' }}</h6>
      <div class="table-responsive mb-3" *ngIf="detail.lines?.length">
        <table class="table table-sm mb-0">
          <thead class="table-light">
            <tr>
              <th>#</th><th>Kalem</th><th class="text-end">Miktar</th><th class="text-end">Birim Fiyat</th>
              <th class="text-end">Tutar</th><th class="text-end">KDV</th><th>Kuyum</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let l of detail.lines">
              <td>{{ l.lineNo }}</td>
              <td>
                {{ l.name }}
                <span class="badge bg-light text-muted border ms-1" *ngIf="detail.type === Type.Sale && isLineRefunded(l.lineNo)">İade edildi</span>
              </td>
              <td class="text-end">{{ l.quantity | number:'1.0-3' }} {{ l.unitCode === 'GRM' ? 'gr' : 'ad' }}</td>
              <td class="text-end">{{ l.unitPrice | number:'1.2-2' }}</td>
              <td class="text-end">{{ l.totalPrice | number:'1.2-2' }}</td>
              <td class="text-end">%{{ l.vatRate }}</td>
              <td class="small text-muted">
                <ng-container *ngIf="l.specialTaxBaseCode">
                  {{ l.specialTaxBaseCode }} · {{ l.gramWeight | number:'1.0-3' }} gr ·
                  has {{ l.hasAmount | number:'1.2-2' }} · işçilik {{ l.labourAmount | number:'1.2-2' }}
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <app-pos-amount-compare [requestJson]="detail.requestJson" [responseJson]="detail.responseJson"></app-pos-amount-compare>

      <!-- Teknik ayrıntı: kapalı gelir, başlığa tıklanınca açılır. -->
      <div class="border rounded mb-2">
        <button type="button" class="btn btn-link text-body text-decoration-none w-100 text-start d-flex align-items-center px-2 py-2"
                (click)="requestOpen = !requestOpen" [disabled]="!detail.requestJson">
          <i class="bx me-1" [ngClass]="requestOpen ? 'bx-chevron-down' : 'bx-chevron-right'"></i>
          <span class="fw-semibold">Gönderilen istek</span>
          <span class="text-muted small ms-2" *ngIf="!detail.requestJson">(yok)</span>
        </button>
        <div class="px-3 pb-2" *ngIf="requestOpen && detail.requestJson">
          <app-pos-json-view [json]="detail.requestJson"></app-pos-json-view>
        </div>
      </div>
      <div class="border rounded">
        <button type="button" class="btn btn-link text-body text-decoration-none w-100 text-start d-flex align-items-center px-2 py-2"
                (click)="responseOpen = !responseOpen" [disabled]="!detail.responseJson">
          <i class="bx me-1" [ngClass]="responseOpen ? 'bx-chevron-down' : 'bx-chevron-right'"></i>
          <span class="fw-semibold">Sağlayıcının son cevabı</span>
          <span class="text-muted small ms-2" *ngIf="!detail.responseJson">(yok)</span>
        </button>
        <div class="px-3 pb-2" *ngIf="responseOpen && detail.responseJson">
          <app-pos-json-view [json]="detail.responseJson"></app-pos-json-view>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
